import React from 'react';
import { useTranslation } from 'react-i18next';
import AppModal from '../AppModal';
import styles from './MobileMessage.module.scss';

type Props = {
  show: boolean;
  onClose?: (source: 'button' | 'backdrop') => void;
  message: string;
  children?: React.ReactNode;
};

const MobileMessage = ({ show, onClose, message, children }: Props) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <AppModal>
      {children && <div className={styles.backView}>{children}</div>}
      <div
        className={styles.backdrop}
        onClick={() => {
          onClose?.('backdrop');
        }}
      />
      <div className={styles.modal}>
        <div className={styles.handle} />
        <p className={styles.text}>{message}</p>
        <button
          className={styles.btn}
          onClick={() => {
            onClose?.('button');
          }}
        >
          {t('ok')}
        </button>
      </div>
    </AppModal>
  );
};

export default MobileMessage;
